import type { AxiosResponse, AxiosError } from 'axios'
import { useAuthStore } from '@/stores/auth'

export function onResponseSuccess(response: AxiosResponse) {
  return response
}

export function onResponseError(error: AxiosError) {
  const status = error.response?.status

  if (status === 401) {
    const authStore = useAuthStore()
    authStore.token = ''
    return Promise.reject(error)
  }

  return Promise.reject(error)
}
